import { umbracoApi } from "~/utils/axios.util";

export interface WidgetFormRequestModel {
    firstName: string;
    lastName: string;
    email: string;
    platform: number;
    sportMoment : number;
}

class WidgetRepository {
    async submit(request: WidgetFormRequestModel) {
        const response = await umbracoApi.post<boolean>('/mail/SendWidgetMail', request)

        return response.data
    };

}

export default new WidgetRepository();